<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h1 class="text-center">Our Value Proporsition</h1>
                    <v-container style="padding-top:25px;">
                        <v-row justify="center">
                            <v-col class="col-content" md="4" style="padding-top:30px;">
                                <v-img src="https://assets.invisee.com/statis/revamp/value/main-1.png" max-height="224px" max-width="268px" class="mx-auto" v-if="activeImg == 1"></v-img>
                                <v-img src="https://assets.invisee.com/statis/revamp/value/main-2.png" max-height="208px" max-width="268px" class="mx-auto" v-if="activeImg == 2"></v-img>
                                <v-img src="https://assets.invisee.com/statis/revamp/value/main-3.png" max-height="268px" max-width="268px" class="mx-auto" v-if="activeImg == 3"></v-img>
                                <v-img src="https://assets.invisee.com/statis/revamp/value/main-4.png" max-height="259px" max-width="268px" class="mx-auto" v-if="activeImg == 4"></v-img>
                            </v-col>
                            <v-col class="col-content" md="8">
                                <v-expansion-panels v-model="panel">
                                    <v-expansion-panel @click="setactiveimage(1)">
                                        <v-expansion-panel-header>
                                            <h3>Regulator Comply</h3>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="text-left">
                                            We adhere to government regulation and laws by keeping track of various policies and ensuring that each one is met so your business will avoid the risks of penalties or lawsuits.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel @click="setactiveimage(2)">
                                        <v-expansion-panel-header>
                                            <h3>Convenient</h3>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="text-left">
                                            We have removed any obstacles, taken care of the due diligence and lincenses for you. With our core wealth system, you can easily offer wealth products right away.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel @click="setactiveimage(3)">
                                        <v-expansion-panel-header>
                                            <h3>Data Driven Insights</h3>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="text-left">
                                            We Provide comprehensive real-time insights that you can use to optimize your performance and make informed business decisions for sustainable growth.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel @click="setactiveimage(4)">
                                        <v-expansion-panel-header>
                                            <h3>Trusted</h3>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="text-left">
                                            We have invested in professionals to conduct strict due diligence on Investment Management companies and wealth product providers to ensure their track records and prospects.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                panel: 0,
                activeImg: 1,
            }
        },
        methods: {
            setactiveimage(_index) {
                switch (_index) {
                case 1:
                    this.activeImg = 1;
                    break;
                case 2:
                    this.activeImg = 2;
                    break;
                case 3:
                    this.activeImg = 3;
                    break;
                case 4:
                    this.activeImg = 4;
                    break;
                }
            },
        },
    }
</script>

<style scoped>
    .v-expansion-panel--active{
        border: 1px solid #0261d8;
    }

    .v-expansion-panel--active h3{
        color: #0261d8;
    }
</style>